import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NavigationLink } from './navigation-link';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
    selector: 'covance-side-nav',
    template: require('./navigation.component.html'),
    styles: [require('./navigation.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationComponent {

    @Input()
    public topLevelMenu: NavigationLink[] = [];

    public queryParams: Observable<Params>;
    
    constructor(route: ActivatedRoute) {
        this.queryParams = route.queryParams;
    }
}